import React, { forwardRef } from 'react';
import { ContainerProps } from './Container';
import {
  Container as StyledContainer,
  Footer,
  Header,
  Filters,
} from './TableContainer.styles';

export type TableContainerProps = Omit<ContainerProps, 'variant'>;

// Update Container to be a forwardRef component
export const Container = forwardRef<HTMLDivElement, ContainerProps>(
  ({ title, children, ...props }, ref) => {
    return (
      <StyledContainer title={title} ref={ref} variant="outlined" {...props}>
        {children}
      </StyledContainer>
    );
  },
);

// Adjust the export to maintain the structured export format
export default { Container, Header, Footer, Filters };
